export const NOTIFICATIONS_UPDATED_EVENT = 'ikompete-notifications-updated';

export const emitNotificationsUpdated = () => {
  window.dispatchEvent(new Event(NOTIFICATIONS_UPDATED_EVENT));
};
